import React, { useContext, useState } from 'react';
import CesiumUI from '../Components/GMRDemo/CesiumUI';
import GMRDate from '../Components/GMRDemo/GMRDate';
import GMRLayer from '../Components/GMRDemo/GMRLayer';
import GMRVisible from '../Components/GMRDemo/GMRVisibile';
import { useEffect } from 'react';
import { siteService } from '../Services/siteService';
import { UserContext } from '../Contexts/UserContext';
import CesiumUIPune from '../Components/GMRDemo/CesiumUIPune';

const Pune = (props) => {
    const { user } = useContext(UserContext);
    const [hasAccess, setHasAccess] = useState(false);
    const [error, setError] = useState(null);
    const [cesiumToken, setCesiumToken] = useState("");

    const [virtualCCZM, setVirtualCCZM] = useState({
        name: "Virtual CCZM",
        visibility: true
    });
    const [overheadTanks, setOverheadTanks] = useState({
        name: "Overhead Tanks",
        visibility: true
    });
    const [buildings, setBuildings] = useState({
        name: "Buildings",
        visibility: true
    });

    const [counter, setCounter] = useState(1);
    const [homePosition, setHomePosition] = useState(null);
    const [position, setPosition] = useState(null);
    const [homeOrientation, setHomeOrientation] = useState(null);
    const [orientation, setOrientation] = useState(null);
    const [vwr, setVwr] = useState(null);
    const [showLeftPanel, setShowLeftPanel] = useState(true);

    const update = () => {
        const camera = vwr.scene.camera;
        const camPos = camera.positionCartographic;
        setPosition({lon: camPos.longitude, lat: camPos.latitude, height: camPos.height});
        setOrientation({heading: camera.heading, pitch: camera.pitch, roll: camera.roll});
        vwr.entities.removeAll();
        vwr.destroy();
        setCounter(counter+1);
    };

    useEffect(() => {
        siteService.getCesiumToken().then((a) => {
            if(a.token != "") {
                setCesiumToken(a.token);
                const hPosition = {
                    lon: Cesium.Math.toRadians(73.86391),
                    lat: Cesium.Math.toRadians(18.54869),
                    height: 4000
                };
                setPosition(hPosition);
                setHomePosition(hPosition);
                const hOrientation = {
                    heading: Cesium.Math.toRadians(360),
                    pitch: Cesium.Math.toRadians(-90),
                    roll: Cesium.Math.toRadians(0)
                };
                setOrientation(hOrientation);
                setHomeOrientation(hOrientation);
                setHasAccess(true);
            } else {
                setError("GMR Innovex application is not configured. Please contact administrator.");
                setHasAccess(false);
            }
        }).catch((err) => {
            setError("GMR Innovex application is not configured. Please contact administrator.");
            setHasAccess(false);
            console.log(err);
        });
    }, [user]);

    if(!hasAccess) {
        if(error != null) {
            return <div><br /><br /><br /><br /><br /> &nbsp; &nbsp; &nbsp; {error} </div>;    
        }
        return <div><br /><br /><br /><br /><br /> &nbsp; &nbsp; &nbsp; If you have access to this page, it would be loaded in a few seconds. Otherwise contact administrator. </div>;
    }

    return <div className={showLeftPanel ? "gmr-innovex-demo gmr-layout" : "gmr-innovex-demo gmr-layout minimized" }>
        <div className='gmr-layout-left'>
            <GMRVisible layer={virtualCCZM} updateLayer={(layer) => setVirtualCCZM(layer)} />
            <GMRVisible layer={overheadTanks} updateLayer={(layer) => setOverheadTanks(layer)} />
            <GMRVisible layer={buildings} updateLayer={(layer) => setBuildings(layer)} />
            <div className='update-btn-container'>
                <input type="button" className='btn btn-primary' name="Update" value="Update" onClick={update} />
            </div>
        </div>
        <div className='gmr-layout-right'>
            <a className='side-toggle' onClick={() => setShowLeftPanel(!showLeftPanel)}><i></i></a>
            <CesiumUIPune 
                      homePosition = {homePosition}
                      homeOrientation = {homeOrientation}
                      virtualCCZM={virtualCCZM}
                      overheadTanks={overheadTanks}
                      buildings={buildings}
                      setViewer={setVwr}
                      accessToken = {cesiumToken}
                      position={position}
                      orientation={orientation}
                      counter={counter}
            />
        </div>
    </div>;
}
export default Pune;